import { getArgsAsTypesafeObjectProperties } from "../constants-util";


export const constants = getArgsAsTypesafeObjectProperties(
    'GET_WEATHERDATA',
    'GET_BACKEND_DMI_DATA'
);

